import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const PasswordField = (props) => {
  const {
    input,
    placeholder,
    label,
    asterisk,
    disabled,
    meta: { touched, error },
  } = props;
  const { t } = useTranslation("master");

  const [showPassword, setShowPassword] = useState(false);
  const [localValue, setLocalValue] = useState(input.value);

  // Sync local state with Redux state
  useEffect(() => {
    setLocalValue(input.value);
  }, [input.value]);

  const handleChange = (e) => {
    setLocalValue(e.target.value); // Update local state
  };

  const handleBlur = () => {
    input.onChange(localValue); // Commit changes to Redux state on blur
  };

  return (
    <>
      <label className="input-label" htmlFor={input.name}>
        <span className="astoricstyle">{asterisk}</span>
        {t(label)}
      </label>
      <div className="password-wrapper" style={{ position: "relative" }}>
        <input
          id={input.name}
          type={showPassword ? "text" : "password"}
          className={
            touched && error
              ? "input-style p-inputtext border-red-500"
              : "input-style p-inputtext"
          }
          placeholder={placeholder}
          value={localValue}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={disabled}
          style={{
            paddingRight: "2.5rem", // Add space for the icon
            borderTopRightRadius: "5px",
            borderBottomRightRadius: "5px",
            width: "100%",
          }}
        />
        <span
          className="password-toggle-icon"
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: "absolute",
            right: "0",
            top: "0",
            height: "88%",
            width: "2.5rem", // Same width as paddingRight
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#666",
            marginTop: "6.5px",
            backgroundColor: "#fff", // Matches the input background
            border: "1px solid #000", // Optional for a divider
            borderTopRightRadius: "5px",
            borderBottomRightRadius: "5px",
            borderTopLeftRadius: "5px",
            borderBottomLeftRadius: "5px",
          }}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </span>
      </div>
      {touched && error && <span className="text-red-500">{error}</span>}
    </>
  );
};

export default PasswordField;
